var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('v-row', [!_vm.$vuetify.breakpoint.mobile ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('category-list', {
    attrs: {
      "return-object": ""
    },
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  })], 1) : _vm._e(), _c('v-col', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "category-icon-wrap border"
  }, [_c('div', {
    staticClass: "category-icon__inner"
  }, [_c('ul', {
    staticClass: "category-icon-ul"
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item._id,
      class: item.class
    }, [_c('a', {
      on: {
        "click": function click($event) {
          return _vm.move(item._id);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.name
      }
    }), _c('p', {
      staticClass: "icon-text"
    }, [_vm._v(_vm._s(item.name))])])]);
  }), 0)])])])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }